export default __webpack_public_path__ + "static/media/counter-closure.448606e5.png";